import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useChatConfig } from '@/ui/ChatProvider';
/**
 * Data mode's line under the header: this chat is the person's alone, and
 * where its answers come from. With `onExitDataMode`, a link back to the
 * ordinary chat — which the team can see, so it is a different place.
 */
export function PrivateNotice() {
    const { copy, onExitDataMode } = useChatConfig();
    return (_jsxs("div", { className: "ac-private-notice", role: "note", children: [_jsx("span", { "aria-hidden": "true", children: "\uD83D\uDD12" }), _jsx("span", { className: "ac-private-text", children: copy.privateNotice }), onExitDataMode && (_jsx("button", { type: "button", className: "ac-link-button", onClick: onExitDataMode, children: copy.backToChat }))] }));
}
